export default "__VITE_ASSET__FXIDqKaj__"